import React, {useState} from "react";
import {Params, useNavigate, useParams} from "react-router-dom";
import ComicPageView from "../../../../../components/comic-page/ComicPageView";
import ComicCommentary from "../../../../../components/comic-commentary/ComicCommentary";
import ContentBox from "../../../../../components/content-box/ContentBox";
import Modal from "../../../../../components/modal/Modal";
import ComicMetadata from "../../../../../model/ComicMetadata";
import PageActions from "../../../../base/PageActions";
import useFetchResult from "../../../../../hooks/UseFetchResult";
import _http_service from "../../../../../services/HttpService";
import _image_service from "../../../../../services/ImageService";
import _naming_service from "../../../../../services/NamingService";
import '../../../../styles/Common.scss';
import '../display/ComicDisplayPage.scss';
import '../ComicPage.scss';

interface AdvanceComicDisplayPageProps {
}

interface AdvanceComicDisplayPageParams extends Params {
    comic: string,
    chapter?: string,
    page?: string,
    id?: string
}

interface AdvanceComicDisplayPageState {
    comic?: string,
    chapter?: number,
    page?: number,
    id?: string
}

interface AdvanceComicDisplayPageResult {
    page: ComicMetadata
}

const AdvanceComicDisplayPage = (props: AdvanceComicDisplayPageProps) => {

    const params = useParams<AdvanceComicDisplayPageParams>();

    const [state] = useState<AdvanceComicDisplayPageState>({
        comic: params.comic,
        chapter: params.chapter ? +params.chapter : undefined,
        page: params.page ? +params.page : undefined,
        id: params.id
    });

    const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);

    const getFullComicTitle = (): string => {
        return `${_naming_service.capitalizeName(state.comic || params.comic || '')} ${state.chapter || params.chapter}-${state.page || params.page}`;
    }

    const page: PageActions = new PageActions({
        title: `${getFullComicTitle()} (Advance) - Chase the Fox`,
        description: `Page ${params.page}, Chapter ${params.chapter} of ${_naming_service.capitalizeName(params.comic || '')}, story and art by Chase the Fox!`,
        keywords: [],
        imgSrc: `chase/comic/talechasers/tale_chasers_logo.png`,
        url: `comics/${params.comic}/${params.chapter}/${params.page}`
    });
    const [isLoading, setLoading] = useState<boolean>(true);

    const navigateTo = useNavigate();

    const [getResult, hasFetchedResult] = useFetchResult<AdvanceComicDisplayPageResult>(undefined, async () => {
        let comic = '';
        let chapter = -1;
        let pageNumber = -1;
        let id: string = "";

        if (!params.comic || params.comic.trim().length === 0
                || !params.chapter || params.chapter.trim().length === 0 || +params.chapter < 0
                || !params.page || params.page.trim().length === 0 || +params.page < 0
                || !params.id || params.id.trim().length === 0) {
            navigateTo("/error", {replace: true});
        } else {
            comic = params.comic;
            chapter = +params.chapter;
            pageNumber = +params.page;
            id = params.id;
        }

        return _http_service.getComicAdvancePage(comic, chapter, pageNumber, id)
            .then(response => {
                if (!response) {
                    throw new Error("Could not fetch advance comic page!");
                }
                
                return {page: response};
            });
    }, []);

    return page.generateMetaContent(
        <>
            <Modal isOpen={modalIsOpen} onClose={() => setModalIsOpen(false)}>
                <div className="comic-modal-view">
                    {hasFetchedResult && <img src={_image_service.getCdnImageSrc(
                        `comics/talechasers/${params.chapter}/${getResult().page.imageId}.png`,
                        'desktop')}
                         alt={getFullComicTitle()}
                         title={getFullComicTitle()}/>}
                </div>
            </Modal>
            <ContentBox key={`comic-${params.comic}-${params.id}`}>
                <img className="comic-header"
                     src={_image_service.getCdnImageSrc(`chase/comic/talechasers/tale_chasers_logo.png`)}
                     alt="Tale Chasers"
                     title="Art and story by Chase the Fox"/>
                <h2 className="headline center">Chapter {params.chapter}, Page {params.page}</h2>
                {hasFetchedResult
                    ? <ComicPageView webImageSrc={_image_service.getCdnImageSrc(
                        `comics/talechasers/${params.chapter}/${getResult().page.imageId}.png`)}
                                     loading={isLoading}
                                     onLoad={() => setLoading(false)}
                                     onClick={() => setModalIsOpen(true)}/>
                    : <></>}
                {hasFetchedResult ? <ComicCommentary comment={getResult().page.commentary!}/> : <></>}
            </ContentBox>
        </>
    );
}

export default AdvanceComicDisplayPage;